import { GetterTree } from 'vuex';
import { State } from './state';

import { RootState } from '@/modules/ewerp/store';
import { Personalstatus } from '@/modules/ewerp/models/PersonalModels';

export type Getters = {
  personal(state: State): Array<Personalstatus>;
};

export const getters: GetterTree<State, RootState> & Getters = {
  personal(state) {
    return state.personal;
  },
};
